<div *ngFor="let option of options"  class="flex align-items-center gap-1">
    <p-checkbox class="mr-2" [name]="name" [(ngModel)]="model" [value]="option" [label]="option" [binary]="binary" (ngModelChange)="onSelectionChanged()"></p-checkbox>
</div>